import  React, {
        useState,
        useEffect,
        useRef,
        useMemo
        }                                   from "react";
import      Style                           from "components/UI/main.module.scss";
import  {   GetSystemLabel,
            GetBusinessLabel,
            GetAppLang,
            Spinner,
            SpinnerSmall,
            sleep,
            q3x_FunData
        }                                   from "Utilities/utils";   
import  {   DatePicker,
            DateFromIsoString,
            DisplayDateAsString,
            DateToString,
            getDateNow,
            compareInitFinDate,
        }                                   from "components/Date/date"
import  {   SearchableDropdownList

        }                                   from "components/DropdownListField/dropdownListFIeld";
import  {   DisplayContent,
            ContentEditor
        }                                    from "components/ContentEditor/contentEditor"; 
import  {   NeedSaveBlock}                   from "components/Validation/needSaveBlock";        
import { pdf } from "@progress/kendo-drawing";

const { PDFExport, PDFMargin    }   = require("@progress/kendo-react-pdf");  


const appLang                    = GetAppLang();

const FeedBackFormSteps          = React.memo(({...props}) => {
    const { Object, SetObject, CanEdit } = props;
    return (
        <React.Fragment>
            <div className={[Style.d_flex, Style.align_items_center, Style.justify_content_start].join(" ")}>
                <span className={[Style.text_body, Style.fs_6].join(" ")}>
                    {GetBusinessLabel("FeedbackFormLabel6")}
                </span>
            </div>            
            {CanEdit ? 
                <ContentEditor 
                    allowHtml={false}
                    elementPath={false}
                    value={Object?.NextSteps}
                    onChange={(event) => {
                        SetObject(prev => {
                            return({
                                ...prev,
                                NeedSave: true,
                                NextSteps : event,
                            });
                        });
                    }}
                />
            :
                <DisplayContent 
                    ContentClass={[Style.text_body].join(" ")}
                    Content={Object?.NextSteps} 
                />
        }
        </React.Fragment>
    );      
});
const FeedBackFormPrivate        = React.memo(({...props}) => {
    const { Object, SetObject, CanEdit } = props;
    useEffect(() => {}, [Object, SetObject, CanEdit]);
    return (
        <React.Fragment>
            <div className={[Style.header_bg, Style.border, Style.rounded_4].join(" ")}>
                <div className={Style.py_2}/>
                <div className={[Style.d_flex, Style.align_items_center, Style.justify_content_start, Style.ms_3].join(" ")}>
                    <div className={[Style.alert_bg, Style.border, Style.rounded_3, Style.shadow_sm].join(" ")}>
                        <span className={[Style.text_body, Style.fs_8, Style.m_3].join(" ")}>
                            {GetBusinessLabel("FeedbackFormLabel3")}
                        </span>
                    </div>
                </div>
                <div className={[Style.d_flex, Style.align_items_center, Style.justify_content_start, Style.py_3, Style.ms_3].join(" ")}>
                    <span className={[Style.text_white, Style.fs_6, Style.fw_semibold].join(" ")}>
                        {GetBusinessLabel("FeedbackFormLabel4")}
                    </span>
                </div>
                <div className={[Style.d_flex, Style.align_items_center, Style.justify_content_start, Style.py_3, Style.ms_3].join(" ")}>
                    <div className={[Style.text_white, Style.fs_8].join(" ")}>
                        {GetBusinessLabel("FeedbackFormLabel5")}
                    </div>
                </div>
                {CanEdit ? 
                        <ContentEditor 
                            allowHtml={false}
                            elementPath={false}
                            value={Object?.ManagerPrivateNotes}
                            onChange={(event) => {
                                SetObject(prev => {
                                    return({
                                        ...prev,
                                        NeedSave: true,
                                        ManagerPrivateNotes : event,
                                    });
                                });
                            }}
                        />
                    :
                        <DisplayContent 
                            ContentClass={[Style.text_white, Style.m_3].join(" ")}
                            Content={Object?.ManagerPrivateNotes} 
                        />
                }  
            </div>
        </React.Fragment>
    );    
});
const FeedBackFormPlan           = React.memo(({...props}) => {
    const { Object, SetObject,  CanEdit} = props;
    return (
        <React.Fragment>
            <div className={[Style.d_flex, Style.align_items_center, Style.justify_content_start].join(" ")}>
                <span className={[Style.text_body, Style.fs_6].join(" ")}>
                    {GetBusinessLabel("FeedbackFormLabel2")}
                </span>
            </div>
            {CanEdit ? 
                    <ContentEditor 
                        allowHtml={false}
                        elementPath={false}
                        value={Object?.DevelopmentPlan}
                        onChange={(event) => {
                            SetObject(prev => {
                                return({
                                    ...prev,
                                    NeedSave: true,
                                    DevelopmentPlan : event,
                                });
                            });
                        }}
                    />
                :
                    <DisplayContent 
                        ContentClass={[Style.text_body].join(" ")}
                        Content={Object?.DevelopmentPlan} 
                    />
            }                        
            <div className={Style.py_3}/>
            <FeedBackFormPrivate 
                CanEdit={CanEdit}
                Object={Object} 
                SetObject={SetObject}
            />
        </React.Fragment>
    );    
});
const FeedBackFormCycle          = React.memo(({...props}) => {
    const { Object, SetObject, CanEdit } = props;
    return (
        <React.Fragment>
            <div className={[Style.d_flex, Style.align_items_center, Style.justify_content_start].join(" ")}>
                <span className={[Style.text_body, Style.fs_6].join(" ")}>
                    {GetBusinessLabel("FeedbackFormLabel0")}
                </span>
            </div>            
            {CanEdit ? 
                    <ContentEditor 
                        allowHtml={false}
                        elementPath={false}
                        value={Object?.EmployeeFeedBack}
                        onChange={(event) => {
                            SetObject(prev => {
                                return({
                                    ...prev,
                                    NeedSave: true,
                                    EmployeeFeedBack : event,
                                });
                            });
                        }}
                    />
                :
                    <DisplayContent 
                        ContentClass={[Style.text_body].join(" ")}
                        Content={Object?.EmployeeFeedBack} 
                    />
            }
            <div className={Style.py_3}/>
            <div className={[Style.d_flex, Style.align_items_center, Style.justify_content_start].join(" ")}>
                <span className={[Style.text_body, Style.fs_6].join(" ")}>
                    {GetBusinessLabel("FeedbackFormLabel1")}
                </span>
            </div>
            {CanEdit ? 
                    <ContentEditor 
                        allowHtml={false}
                        elementPath={false}
                        value={Object?.ManagerFeedBack}
                        onChange={(event) => {
                            SetObject(prev => {
                                return({
                                    ...prev,
                                    NeedSave: true,
                                    ManagerFeedBack : event,
                                });
                            });
                        }}
                    />    
                :
                    <DisplayContent 
                        ContentClass={[Style.text_body].join(" ")}
                        Content={Object?.ManagerFeedBack} 
                    />
            }                                  
        </React.Fragment>
    );    
});
const FeedBackFormStageContent   = React.memo(({...props}) => {
    const { Current, CanEdit, Content, visible }      = props;
    const isActive = Current?.DevelopmentStageId === Content?.DevelopmentStageId;
    useState(() => {}, [Current, CanEdit, Content, visible]);

    return (
        <div
            className={[ Style.row, visible && isActive ? Style.text_animation_fadein : Style.text_animation_fadeout].join(" ")}
            style={{ display: isActive ? "block" : "none" }}
        >
            <div className={Style.col}>
                <div className={[Style.m_2].join(" ")}>
                    <DisplayContent 
                        ContentClass={[Style.text_body].join(" ")}
                        Content={Content?.[`DevelopmentStageDesc${GetAppLang()}`]} 
                    />
                </div>
            </div>
        </div>
    ); 
});
const FeedBackFormStageHeader    = React.memo(({...props}) => {
    const { Current, CanEdit, SetCurrent, Content }      = props;
    useState(() => {}, [ Current, SetCurrent, CanEdit, Content]);
    return (
        <React.Fragment>
            <div onClick={() => {SetCurrent(Content?.DevelopmentStageId)}} className={[Style.border, Style.rounded_3, Style.m_3, Style.clickable, Style.pop_item_animation, Style.vanilla_bg].join(" ")}>
                    <div className={[Style.d_flex, Style.align_items_center, Style.justify_content_center, Style.p_3].join(" ")}>
                        <input
                            type="checkbox"
                            name={"read"}
                            style={{
                                width: '1.1rem',
                                height: '1.1rem',
                                appearance: 'none',
                                WebkitAppearance: 'none',
                                borderRadius: '50%',                        
                                outline: 'none',
                                transition: 'background-color 0.5s, border-color 0.1s',
                            }}
                            disabled={false}
                            className={[Content?.DevelopmentStageId === Current?.DevelopmentStageId ? Style.stepper_active_bg : Style.stepper_bg, Style.clickable].join(" ")}
                        />
                        <span   className={[
                                        Style.ms_1,
                                        Style.fs_8,
                                        (Current?.DevelopmentStageId === Content?.DevelopmentStageId) ? Style.text_body_active            : Style.text_body, 
                                        (Current?.DevelopmentStageId === Content?.DevelopmentStageId) ? Style.text_decoration_underline   : null, 
                                        ].join(" ")
                                }
                        >
                            {Content?.[`DevelopmentStageName${GetAppLang()}`]}
                        </span>
                    </div>
            </div>
        </React.Fragment>
    );    
});
const FeedBackFormStage          = React.memo(({...props}) => {
    const { Object, CanEdit, SetObject, StageList, }         = props;
    const [visible,     setVisible]                 = useState(true);

    const handleDisplay = async (id) => {
        // fade out
        setVisible(false);

        await sleep(300);

        // switch content
        SetObject(prev => {
            return({
                ...prev,
                NeedSave: true,
                DevelopmentStageId: id,
            });
        });

        // fade in
        setVisible(true);
    };

    const _obj = StageList?.find(
        (d) => Object?.DevelopmentStageId === d.DevelopmentStageId
    );

    useEffect(() => {}, [Object, SetObject, CanEdit, StageList]);
    return (
        StageList ? 
            <React.Fragment>
                <div className={[Style.card_bg, Style.rounded_3, ].join(" ")}>
                    {CanEdit?
                            <React.Fragment>
                                <div className={Style.row}>
                                    <div className={Style.col}>
                                        <div className={[Style.d_flex, Style.align_self_baseline, Style.justify_content_around, Style.overflow_x_auto].join(" ")}>
                                            {StageList?.map((d) => (
                                                <FeedBackFormStageHeader 
                                                    Current={Object}
                                                    SetCurrent={handleDisplay}
                                                    Content={d}
                                                />
                                            ))}
                                        </div>
                                    </div>
                                </div>                    
                                <div className={Style.row}>
                                    <div className={Style.col}>
                                        {StageList?.map((d) => (
                                            <FeedBackFormStageContent 
                                                key={d.DevelopmentStageId}
                                                Current={Object}
                                                Content={d}
                                                visible={visible}
                                            />
                                        ))}           
                                    </div>
                                </div>
                            </React.Fragment>   
                        :
                            <React.Fragment>
                                <div className={[Style.d_flex, Style.align_items_center, Style.justify_content_start, Style.p_3].join(" ")}>
                                    <span   className={[Style.ms_1,Style.fs_8].join(" ")}>
                                        {_obj?.[`DevelopmentStageName${GetAppLang()}`]}
                                    </span>
                                </div>
                                <DisplayContent 
                                    ContentClass={[].join(" ")}
                                    Content={_obj?.[`DevelopmentStageDesc${GetAppLang()}`]} 
                                />
                            </React.Fragment>
                    }
                </div>
            </React.Fragment>
        :
            <React.Fragment>
                <SpinnerSmall/>
            </React.Fragment>
    ); 
});
const FeedBackFormInfo           = React.memo(({...props}) => {
    const { Object, 
            SetObject,  
            CanEdit, 
            Content, 
            UserMentorsList,
            DepartmentList,
            AssignmentList,
            DepartmentAssignmentList
    } = props;
    const [meta, setMeta] = useState(null);
    
    const _objUser = UserMentorsList?.find((d) => Object?.MentorId === d.UserId);

    useEffect(() => {
        if (CanEdit && Object?.FillStatusId === 0) {
            const department = DepartmentAssignmentList?.find((d) => Object?.DepartmentId === d.DepartmentId);
            if (department) setMeta(department);
        }
        else {
            const department = DepartmentList?.find((d) => Object?.DepartmentId === d.DepartmentId);
            const assignment = AssignmentList?.find((d) => Object?.AssignmentId === d.AssignmentId);
            setMeta({
                ...department,
                Assignments: assignment ? [assignment] : [],
            });
        }
    }, [Object, SetObject,  CanEdit, Content, UserMentorsList, DepartmentList, AssignmentList, DepartmentAssignmentList]);

    return (
        <React.Fragment>
            <div className={[   Style.row,
                                Style.d_flex,
                                Style.align_items_center].join(" ")}>
                <div className={[Style.col_lg].join(" ")}>
                    <div className={Style.m_3}>
                        <div    className={[Style.d_flex, Style.align_items_center, Style.justify_content_start].join(" ")}>
                            <span className={[Style.fs_6, Style.text_body].join(" ")}>
                                {GetBusinessLabel("Contributor")}
                            </span>                                
                        </div>
                        <div    className={[Style.d_flex, Style.align_items_center, Style.justify_content_start].join(" ")}>
                            <span className={[Style.fs_8, Style.text_body].join(" ")}>
                                {Content?.MenteeFirstName} {Content?.MenteeLastName}
                            </span>                                
                        </div>
                    </div>
                </div>                             
                <div className={[Style.col_lg].join(" ")}>
                    <div className={Style.m_3}>
                        <div    className={[Style.d_flex, Style.align_items_center, Style.justify_content_start].join(" ")}>
                            <span className={[Style.fs_6, Style.text_body].join(" ")}>
                                {GetBusinessLabel("Area")}
                            </span>                                
                        </div>
                        <div    className={[Style.d_flex, Style.align_items_center, Style.justify_content_start].join(" ")}>
                            {DepartmentList ?
                                    <span className={[Style.fs_8, Style.text_body].join(" ")}>
                                        {(meta !== null && meta !== undefined) && (`${meta?.DepartmentName}`)}
                                    </span>    
                                :
                                    <SpinnerSmall/>   
                            }
                        </div>
                    </div>
                </div>
                <div className={[Style.col_lg].join(" ")}>
                    <div className={Style.m_3}>
                        <div    className={[Style.d_flex, Style.align_items_center, Style.justify_content_start].join(" ")}>
                            <span className={[Style.fs_6, Style.text_body].join(" ")}>
                                {`${GetBusinessLabel("Function")}*`}
                            </span>                                
                        </div>
                        <div    className={[Style.d_flex, Style.align_items_center, Style.justify_content_start].join(" ")}>
                            {CanEdit && Object.FillStatusId === 0 ? 
                                <SearchableDropdownList    
                                    placeholder={GetBusinessLabel("Assignment")}                                
                                    listOfItems={
                                        meta?.Assignments && Array.isArray(meta?.Assignments)
                                        ? 
                                            meta?.Assignments.map((d) => ({ value: d.AssignmentId, label: d[`AssignmentName${appLang}`] }))
                                        : 
                                            null
                                    }
                                    style={{ width: "100%" }}  
                                    className={Style.antd_custom_select}                               
                                    popupClassName={Style.antd_custom_select}                              
                                    onChange={(event) => {            
                                        SetObject(prev => ({
                                            ...prev,
                                            NeedSave: true,
                                            AssignmentId: event
                                        }));
                                    }}
                                    value={Object.AssignmentId > 0 ? parseInt(Object.AssignmentId) : undefined}
                                />  
                            :
                                <span className={[Style.fs_8, Style.text_body].join(" ")}>
                                    {AssignmentList && Array.isArray(AssignmentList)
                                        ? AssignmentList?.find((d) => Number(Object?.AssignmentId) === Number(d.AssignmentId))?.[`AssignmentName${appLang}`]
                                        : undefined
                                    }
                                </span> 
                            }                        
                        </div>
                    </div>
                </div>
            </div>
            <div className={[   Style.row,
                                Style.d_flex,
                                Style.align_items_center].join(" ")}>
                <div className={[Style.col_lg].join(" ")}>
                    <div className={Style.m_3}>
                        <div    className={[Style.d_flex, Style.align_items_center, Style.justify_content_start].join(" ")}>
                            <span className={[Style.fs_6, Style.text_body].join(" ")}>
                                {`${GetBusinessLabel("FeedbackFormDateFeed")}*`}
                            </span>                                
                        </div>
                        <div    className={[Style.d_flex, Style.align_items_center, Style.justify_content_start].join(" ")}>
                            {CanEdit ? 
                                    <DatePicker
                                        placeholder={GetBusinessLabel("FeedbackFormDateFeed")}
                                        style={{width: '100%'}}
                                        value={Object?.FeedBackDate}
                                        onChange={(date) => {
                                            SetObject(prev => ({
                                                ...prev,
                                                NeedSave: true,
                                                FeedBackDate: date,
                                            }));
                                        }}
                                    /> 
                                :
                                    <span className={[Style.fs_8, Style.text_body].join(" ")}>
                                        {DisplayDateAsString(Object?.FeedBackDate, false)}
                                    </span>    
                            }                                  
                        </div>
                    </div>
                </div>                             
                <div className={[Style.col_lg].join(" ")}>
                    <div className={Style.m_3}>
                        <div    className={[Style.d_flex, Style.align_items_center, Style.justify_content_start].join(" ")}>
                            <span className={[Style.fs_6, Style.text_body].join(" ")}>
                                {`${GetBusinessLabel("ResponsibleMentor")}*`}
                            </span>                                
                        </div>
                        <div    className={[Style.d_flex, Style.align_items_center, Style.justify_content_start].join(" ")}>
                            {CanEdit ? 
                                    UserMentorsList ?
                                        <SearchableDropdownList    
                                            placeholder={GetBusinessLabel("Mentor")}
                                            listOfItems={
                                                UserMentorsList && Array.isArray(UserMentorsList)
                                                ? 
                                                    UserMentorsList?.map((d) => ({ value: d.UserId, label: [`${d.FirstName} ${d.LastName}`] }))
                                                : 
                                                    null
                                            }
                                            style={{ width: "100%" }}  
                                            className={Style.antd_custom_select}                               
                                            popupClassName={Style.antd_custom_select}                              
                                            onChange={(event) => {            
                                                SetObject(prev => ({
                                                    ...prev,
                                                    NeedSave: true,
                                                    MentorId: event
                                                }));
                                            }}
                                            value={Object.MentorId > 0 ? parseInt(Object.MentorId) : undefined}
                                        />
                                    :
                                        <SpinnerSmall/>
                                :
                                    UserMentorsList ?
                                        <span className={[Style.fs_8, Style.text_body].join(" ")}>
                                            {(_objUser !== null && _objUser !== undefined) && (`${_objUser?.FirstName} ${_objUser?.LastName}`)}
                                        </span>    
                                    :
                                        <SpinnerSmall/>                                    
                            }                             
                        </div>
                    </div>
                </div>
            </div>            
        </React.Fragment>
    );    
});
const FeedBackFormHistory        = React.memo(({...props}) => {
    const {     Content,
                History = undefined
    }                                       = props;
    useEffect(() => {}, [History]);

    return (
        <React.Fragment>
            <div className={[Style.row,
                            Style.d_flex,
                            Style.align_items_center].join(" ")}
            >
                <div className={[Style.col_lg_8].join(" ")}>
                    <div className={[Style.d_flex, Style.align_items_center, Style.justify_content_start, Style.m_3].join(" ")}>
                        <div className={[Style.link_visited_bg, Style.border, Style.rounded_3, Style.shadow_sm].join(" ")}>
                            <span className={[Style.text_iheading, Style.fs_8, Style.m_3].join(" ")}>
                                {Content?.[`PeriodLabelName${GetAppLang()}`]} {GetSystemLabel("of")} {Content?.CycleYear}
                            </span>
                        </div>
                    </div>
                    <div    className={[Style.d_flex, Style.align_items_center, Style.justify_content_start,  Style.m_3].join(" ")}>
                        <span className={[Style.fs_6, Style.text_body, Style.fw_semibold].join(" ")}>
                            {GetBusinessLabel("FeedbackFormLabel7")} {Content?.MenteeFirstName} {Content?.MenteeLastName}
                        </span>                                
                    </div>        
                    <div    className={[Style.d_flex, Style.align_items_center, Style.justify_content_start,  Style.m_3].join(" ")}>
                        <div className={[Style.text_body].join(" ")}>
                            {History === undefined  ? 
                                <SpinnerSmall/>
                                :
                                History?.MentorId ? (
                                    <React.Fragment>
                                        <span className={[Style.fw_semibold, Style.fs_6].join(" ")}>
                                            {` ${GetBusinessLabel("ResponsibleMentor")}: `}
                                        </span> 
                                        <span className={[Style.fs_8].join(" ")}>
                                            {History?.MentorFirstName} {History?.MentorLastName} 
                                        </span>
                                        <span className={[Style.fw_semibold, Style.fs_6].join(" ")}>
                                            {` ${GetBusinessLabel("Area")}: `}
                                        </span>
                                        <span className={[Style.fs_8].join(" ")}>
                                            {History?.DepartmentName}
                                        </span>
                                        <span className={[Style.fw_semibold, Style.fs_6].join(" ")}>
                                            {` ${GetBusinessLabel("Function")}: `}
                                        </span>
                                        <span className={[Style.fs_8].join(" ")}>
                                            {History?.[`AssignmentName${appLang}`]}
                                        </span>                                         
                                    </React.Fragment>
                                )
                                : 
                                null
                            }
                        </div>                                
                    </div>         
                </div>     
                {History?.FeedBackId ?
                    (
                    <div className={[Style.col_lg].join(" ")}>
                        <div className={[Style.d_flex, Style.align_items_center, Style.justify_content_center, Style.m_3].join(" ")}>
                            <div className={[Style.card_bg, Style.border, Style.rounded_3, Style.shadow_sm, , Style.mx_3].join(" ")}>
                                <div className={Style.m_3}>
                                    <div className={[Style.d_flex, Style.align_items_center, Style.justify_content_center].join(" ")}>                                
                                        <span className={[Style.text_body, Style.fs_8, Style.fw_semibold, Style.text_pre_wrap].join(" ")}>
                                            {GetBusinessLabel("LastFeedBack")}
                                        </span>                                
                                    </div>
                                    <div className={[Style.d_flex, Style.align_items_center, Style.justify_content_center].join(" ")}>
                                        <span className={[Style.text_body, Style.fs_8, Style.text_pre_wrap].join(" ")}>
                                            {History?.FeedBackDate && ( DateToString({displayTime: false, date: DateFromIsoString(History?.FeedBackDate)}))}
                                        </span>                                
                                    </div>
                                </div>
                            </div>
                            <div className={[Style.card_bg, Style.border, Style.rounded_3, Style.shadow_sm, Style.mx_3].join(" ")}>
                                <div className={Style.m_3}>
                                    <div className={[Style.d_flex, Style.align_items_center, Style.justify_content_center].join(" ")}>                                
                                        <span className={[Style.text_body, Style.fs_8, Style.fw_semibold, Style.text_pre_wrap].join(" ")}>
                                            {GetBusinessLabel("FeedbackFormLabel8")}
                                        </span>                                
                                    </div>
                                    <div className={[Style.d_flex, Style.align_items_center, Style.justify_content_center].join(" ")}>
                                        <span className={[Style.text_body, Style.fs_8, Style.text_pre_wrap].join(" ")}>
                                            {History?.[`DevelopmentStageName${GetAppLang()}`]}
                                        </span>                                
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    )
                :
                    null
                }
            </div>
        </React.Fragment>
    );    
});
export const FeedBackForm        = React.memo(({...props}) => {
    const { History, 
            Object, 
            SetObject, 
            StageList, 
            UserMentorsList, 
            DepartmentList, 
            AssignmentList, 
            DepartmentAssignmentList,
            Content, 
            Context
    }             = props;
    const canEdit = compareInitFinDate(getDateNow(), DateFromIsoString(Context?.EndDate));
    useEffect(() => {}, [History, StageList, UserMentorsList, DepartmentList, AssignmentList, DepartmentAssignmentList]);

    return (
        <React.Fragment>
            <div className={[Style.card_bg, Style.rounded_3, Style.border].join(" ")}>
                <div className={[Style.m_3].join(" ")}>
                    <FeedBackFormHistory 
                        CanEdit={canEdit}
                        Content={Content}
                        History={History}
                        DepartmentList={DepartmentList}
                        AssignmentList={AssignmentList}
                        DepartmentAssignmentList={DepartmentAssignmentList}                        
                    />
                </div>
            </div>
            <div className={Style.py_3}>
                <span className={[Style.fs_6, Style.text_body, Style.fw_semibold].join(" ")}>
                    {GetBusinessLabel("FeedbackFormHeader0")}
                </span>
                <div className={Style.py_3}/>
                <NeedSaveBlock Boolean={Object?.NeedSave}/>
                <div className={[Style.card_bg, Style.rounded_3, Style.border].join(" ")}>
                    <div className={[Style.m_3].join(" ")}>
                        <FeedBackFormInfo   
                            CanEdit={canEdit}
                            Content={Content}
                            Object={Object} 
                            SetObject={SetObject}
                            UserMentorsList={UserMentorsList}
                            DepartmentList={DepartmentList}
                            AssignmentList={AssignmentList}
                            DepartmentAssignmentList={DepartmentAssignmentList}
                        />
                    </div>
                </div>
            </div>            
            <div className={Style.py_3}>
                <span className={[Style.fs_6, Style.text_body, Style.fw_semibold].join(" ")}>
                    {GetBusinessLabel("FeedbackFormHeader1")}
                </span>
                <div className={Style.py_3}/>
                <NeedSaveBlock Boolean={Object?.NeedSave}/>
                <div className={[Style.card_bg, Style.rounded_3, Style.border].join(" ")}>
                    <div className={[Style.m_3].join(" ")}>
                        <FeedBackFormCycle  
                            CanEdit={canEdit}
                            Object={Object} 
                            SetObject={SetObject} 
                        />
                    </div>
                </div>
            </div>
            <div className={Style.py_3}>
                <span className={[Style.fs_6, Style.text_body, Style.fw_semibold].join(" ")}>
                    {GetBusinessLabel("FeedbackFormHeader2")}
                </span>
                <div className={Style.py_3}/>
                <NeedSaveBlock Boolean={Object?.NeedSave}/>
                <div className={[Style.card_bg, Style.rounded_3, Style.border].join(" ")}>
                    <div className={[Style.m_3].join(" ")}>
                        <FeedBackFormPlan  
                            CanEdit={canEdit}
                            Object={Object} 
                            SetObject={SetObject} 
                        />
                    </div>
                </div>                
            </div>
            <div className={Style.py_3}>
                <span className={[Style.fs_6, Style.text_body, Style.fw_semibold].join(" ")}>
                    {GetBusinessLabel("FeedbackFormHeader3")}
                </span>
                <div className={Style.py_3}/>
                <NeedSaveBlock Boolean={Object?.NeedSave}/>                
                <div className={[Style.card_bg, Style.rounded_3, Style.border].join(" ")}>
                    <div className={[Style.m_3].join(" ")}>
                        <FeedBackFormStage  
                            CanEdit={canEdit}
                            Object={Object} 
                            SetObject={SetObject} 
                            StageList={StageList}
                        />
                    </div>
                </div>                 
            </div>
            <div className={Style.py_3}>
                <span className={[Style.fs_6, Style.text_body, Style.fw_semibold].join(" ")}>
                    {GetBusinessLabel("FeedbackFormHeader4")}
                </span>
                <div className={Style.py_3}/>
                <NeedSaveBlock Boolean={Object?.NeedSave}/>
                <div className={[Style.card_bg, Style.rounded_3, Style.border].join(" ")}>
                    <div className={[Style.m_3].join(" ")}>
                        <FeedBackFormSteps  
                            CanEdit={canEdit}
                            Object={Object} 
                            SetObject={SetObject} 
                        />
                    </div>
                </div>                   
            </div>
        </React.Fragment>
    );
});








const PDF_FONT_FAMILY = "OpenSansPdf";
const PUBLIC_URL = (process.env.PUBLIC_URL || "").replace(/\/$/, "");
const PDF_FONT_BASE = `${PUBLIC_URL}/fonts`;

pdf.defineFont({[PDF_FONT_FAMILY]: `${PDF_FONT_BASE}/OpenSans-Regular.ttf`, [`${PDF_FONT_FAMILY}|Bold`]: `${PDF_FONT_BASE}/OpenSans-Bold.ttf`});

const ReportStyle = {
    page: {
        width: "94%",
        minHeight: "297mm",
        margin: "0 auto",
        background: "#FFFFFF",
        padding: "22mm 18mm 20mm 18mm",
        boxSizing: "border-box",
        color: "#2f3032",
        fontFamily: PDF_FONT_FAMILY,
        fontSize: "11.2pt",
        lineHeight: 1.45
    },

    report_header: {
        display: "grid",
        gridTemplateColumns: "1fr auto",
        gap: "18px",
        paddingBottom: "18px",
        borderBottom: "3px solid #005EB2"
    },

    report_header_accent: {
        width: "36mm",
        height: "3px",
        background: "#02ADE1",
        marginTop: "-3px",
        marginBottom: "20px"
    },

    eyebrow: {
        margin: "0 0 8px 0",
        color: "#005EB2",
        fontSize: "8.5pt",
        fontWeight: 700,
        letterSpacing: "0.12em",
        textTransform: "uppercase"
    },

    h1: {
        margin: 0,
        color: "#4D4D4F",
        fontSize: "23pt",
        lineHeight: 1.1,
        letterSpacing: "-0.03em",
        fontWeight: 700
    },

    subtitle: {
        margin: "9px 0 0 0",
        color: "#939397",
        fontSize: "10.5pt",
        maxWidth: "128mm"
    },

    meta_box: {
        minWidth: "45mm",
        border: "1px solid #B8BABC",
        borderTop: "4px solid #005EB2",
        padding: "10px 12px",
        alignSelf: "start",
        background: "#FFFFFF"
    },

    meta_label: {
        display: "block",
        color: "#939397",
        fontSize: "8pt",
        fontWeight: 700,
        textTransform: "uppercase",
        letterSpacing: "0.08em",
        marginBottom: "3px"
    },

    meta_value: {
        display: "block",
        fontSize: "10.5pt",
        fontWeight: 700,
        color: "#4D4D4F"
    },

    history: {
        display: "grid",
        gridTemplateColumns: "1fr 46mm",
        gap: "14px",
        border: "1px solid #d8dadd",
        borderLeft: "5px solid #005EB2",
        padding: "13px 15px",
        marginTop: "20px",
        background: "#f7f8f9",
        boxSizing: "border-box"
    },

    history_title: {
        color: "#4D4D4F",
        fontSize: "13pt",
        fontWeight: 700,
        letterSpacing: "-0.01em",
        marginBottom: "4px"
    },

    history_subtitle: {
        color: "#939397",
        fontSize: "10pt",
        marginBottom: "9px"
    },

    history_tags: {
        display: "flex",
        flexWrap: "wrap",
        gap: "6px"
    },

    tag: {
        border: "1px solid #d8dadd",
        background: "#FFFFFF",
        padding: "4px 7px",
        fontSize: "8.5pt",
        color: "#4D4D4F"
    },

    tag_strong: {
        color: "#005EB2"
    },

    side_metrics: {
        display: "grid",
        gap: "8px"
    },

    metric: {
        border: "1px solid #d8dadd",
        background: "#FFFFFF",
        padding: "9px 10px"
    },

    metric_label: {
        display: "block",
        color: "#939397",
        fontSize: "7.8pt",
        fontWeight: 700,
        textTransform: "uppercase",
        letterSpacing: "0.08em",
        marginBottom: "3px"
    },

    metric_value: {
        display: "block",
        color: "#4D4D4F",
        fontWeight: 700,
        fontSize: "10pt"
    },

    section: {
        marginTop: "22px",
        breakInside: "avoid",
        pageBreakInside: "avoid"
    },

    section_title: {
        display: "flex",
        alignItems: "baseline",
        gap: "10px",
        marginBottom: "9px",
        paddingBottom: "7px",
        borderBottom: "1px solid #d8dadd"
    },

    section_number: {
        color: "#005EB2",
        fontSize: "8.5pt",
        fontWeight: 700,
        letterSpacing: "0.08em"
    },

    h2: {
        margin: 0,
        color: "#4D4D4F",
        fontSize: "13pt",
        lineHeight: 1.2,
        letterSpacing: "-0.01em",
        fontWeight: 700
    },

    info_grid: {
        display: "grid",
        gridTemplateColumns: "repeat(3, 1fr)",
        border: "1px solid #d8dadd"
    },

    field: {
        minHeight: "18mm",
        padding: "10px 12px",
        borderRight: "1px solid #eef0f2",
        borderBottom: "1px solid #eef0f2",
        background: "#FFFFFF",
        boxSizing: "border-box"
    },

    no_right_border: {
        borderRight: 0
    },

    no_bottom_border: {
        borderBottom: 0
    },

    field_label: {
        display: "block",
        color: "#939397",
        fontSize: "8pt",
        fontWeight: 700,
        textTransform: "uppercase",
        letterSpacing: "0.07em",
        marginBottom: "4px"
    },

    field_value: {
        display: "block",
        color: "#4D4D4F",
        fontSize: "10.5pt",
        fontWeight: 600
    },

    content_card: {
        border: "1px solid #d8dadd",
        borderLeft: "3px solid #B8BABC",
        padding: "13px 15px",
        marginTop: "10px",
        background: "#FFFFFF",
        boxSizing: "border-box"
    },

    content_card_primary: {
        borderLeftColor: "#005EB2"
    },

    content_card_secondary: {
        borderLeftColor: "#02ADE1"
    },

    content_card_spacing: {
        marginTop: "11px"
    },

    content_label: {
        color: "#005EB2",
        fontSize: "8.2pt",
        fontWeight: 700,
        textTransform: "uppercase",
        letterSpacing: "0.08em",
        marginBottom: "7px"
    },

    p: {
        margin: 0
    },

    stage_card: {
        display: "grid",
        gridTemplateColumns: "46mm 1fr",
        border: "1px solid #d8dadd",
        background: "#f7f8f9"
    },

    stage_name: {
        padding: "14px 15px",
        borderRight: "1px solid #d8dadd",
        background: "#4D4D4F",
        color: "#FFFFFF"
    },

    stage_name_value: {
        display: "block",
        fontSize: "13.5pt",
        fontWeight: 700,
        letterSpacing: "-0.02em"
    },

    stage_caption: {
        display: "block",
        marginTop: "5px",
        color: "#d9dadd",
        fontSize: "8.3pt",
        fontWeight: 700,
        textTransform: "uppercase",
        letterSpacing: "0.08em"
    },

    stage_description: {
        padding: "14px 15px",
        background: "#FFFFFF"
    },

    footer: {
        paddingTop: "9px",
        borderTop: "1px solid #d8dadd",
        color: "#939397",
        fontSize: "8.5pt",
        display: "flex",
        justifyContent: "space-between",
        gap: "14px",
        width: '96%',
    },

    footer_strong: {
        color: "#005EB2",
        fontWeight: 700
    },

    display_content: {
        fontFamily: PDF_FONT_FAMILY,
        fontSize: "11.2pt",
        lineHeight: 1.45,
        color: "#2f3032"
    }
};

const PdfDisplayContent = React.memo(({ Content }) => {
    return (
        <div
            style={{ ...ReportStyle.display_content }}
            dangerouslySetInnerHTML={{ __html: Content || "" }}
        />
    );
});

const DocumentSteps = React.memo(({...props}) => {
    const { Object } = props;

    return (
        <React.Fragment>
            <section style={{ ...ReportStyle.section }}>
                <div style={{ ...ReportStyle.section_title }}>
                    <span style={{ ...ReportStyle.section_number }}>
                        05
                    </span>

                    <h2 style={{ ...ReportStyle.h2 }}>
                        {GetBusinessLabel("FeedbackFormHeader4")}
                    </h2>
                </div>

                <div style={{ ...ReportStyle.content_card, ...ReportStyle.content_card_primary }}>
                    <div style={{ ...ReportStyle.content_label }}>
                        {GetBusinessLabel("FeedbackFormHeader4")}
                    </div>

                    <div style={{ ...ReportStyle.p }}>
                        <PdfDisplayContent ContentStyle={ReportStyle.display_content} ContentClass={[].join(" ")} Content={Object?.NextSteps}/>
                    </div>
                </div>
            </section>
        </React.Fragment>
    );
});

const DocumentPlan = React.memo(({...props}) => {
    const { Object } = props;

    return (
        <React.Fragment>
            <section style={{ ...ReportStyle.section }}>
                <div style={{ ...ReportStyle.section_title }}>
                    <span style={{ ...ReportStyle.section_number }}>
                        03
                    </span>

                    <h2 style={{ ...ReportStyle.h2 }}>
                        {GetBusinessLabel("FeedbackFormHeader2")}
                    </h2>
                </div>

                <div style={{ ...ReportStyle.content_card, ...ReportStyle.content_card_primary }}>
                    <div style={{ ...ReportStyle.content_label }}>
                        {GetBusinessLabel("FeedbackFormLabel2")}
                    </div>

                    <div style={{ ...ReportStyle.p }}>
                        <PdfDisplayContent ContentStyle={ReportStyle.display_content} ContentClass={[Style.fw_bold].join(" ")} Content={Object?.DevelopmentPlan} />
                    </div>
                </div>
                {Object?.ManagerPrivateNotes && (
                    <div style={{ ...ReportStyle.content_card, ...ReportStyle.content_card_secondary, ...ReportStyle.content_card_spacing }}>
                        <div style={{ ...ReportStyle.content_label }}>
                            {GetBusinessLabel("FeedbackFormLabel9")}
                        </div>

                        <div style={{ ...ReportStyle.p }}>
                            <PdfDisplayContent ContentStyle={ReportStyle.display_content} ContentClass={[].join(" ")} Content={Object?.ManagerPrivateNotes} />
                        </div>
                    </div>
                )}
            </section>
        </React.Fragment>
    );
});

const DocumentCycle = React.memo(({...props}) => {
    const { Object } = props;

    return (
        <React.Fragment>
            <section style={{ ...ReportStyle.section }}>
                <div style={{ ...ReportStyle.section_title }}>
                    <span style={{ ...ReportStyle.section_number }}>
                        02
                    </span>

                    <h2 style={{ ...ReportStyle.h2 }}>
                        {GetBusinessLabel("FeedbackFormHeader1")}
                    </h2>
                </div>

                <div style={{ ...ReportStyle.content_card, ...ReportStyle.content_card_primary }}>
                    <div style={{ ...ReportStyle.content_label }}>
                        {GetBusinessLabel("FeedbackFormLabel0")}
                    </div>

                    <div style={{ ...ReportStyle.p }}>
                        <PdfDisplayContent
                            ContentStyle={ReportStyle.display_content}
                            ContentClass={[].join(" ")}
                            Content={Object?.EmployeeFeedBack}
                        />
                    </div>
                </div>

                <div style={{ ...ReportStyle.content_card, ...ReportStyle.content_card_spacing }}>
                    <div style={{ ...ReportStyle.content_label }}>
                        {GetBusinessLabel("FeedbackFormLabel1")}
                    </div>

                    <div style={{ ...ReportStyle.p }}>
                        <PdfDisplayContent
                            ContentStyle={ReportStyle.display_content}
                            ContentClass={[].join(" ")}
                            Content={Object?.ManagerFeedBack}
                        />
                    </div>
                </div>
            </section>
        </React.Fragment>
    );
});

const DocumentStage = React.memo(({...props}) => {
    const { Object, StageList } = props;
    useState(() => {}, [Object, StageList]);

    if (!StageList?.length) return null;

    const _obj = StageList?.find(
        (d) => Object?.DevelopmentStageId === d.DevelopmentStageId
    );

    return (
        <React.Fragment>
            <section style={{ ...ReportStyle.section }}>
                <div style={{ ...ReportStyle.section_title }}>
                    <span style={{ ...ReportStyle.section_number }}>
                        04
                    </span>

                    <h2 style={{ ...ReportStyle.h2 }}>
                        {GetBusinessLabel("FeedbackFormHeader3")}
                    </h2>
                </div>

                <div style={{ ...ReportStyle.stage_card }}>
                    <div style={{ ...ReportStyle.stage_name }}>
                        <span style={{ ...ReportStyle.stage_name_value }}>
                            {_obj?.[`DevelopmentStageName${GetAppLang()}`]}
                        </span>

                        <span style={{ ...ReportStyle.stage_caption }}>
                            {GetBusinessLabel("FeedbackFormHeader3")}
                        </span>
                    </div>

                    <div style={{ ...ReportStyle.stage_description }}>
                        <div style={{ ...ReportStyle.p }}>
                            <PdfDisplayContent
                                ContentStyle={ReportStyle.display_content}
                                ContentClass={[].join(" ")}
                                Content={_obj?.[`DevelopmentStageDesc${GetAppLang()}`]}
                            />
                        </div>
                    </div>
                </div>
            </section>
        </React.Fragment>
    );
});

const DocumentInfo = React.memo(({...props}) => {
    const { Object, Content, UserMentorsList, DepartmentList, AssignmentList } = props;
    const _objUser       = UserMentorsList?.find((d) => Object?.MentorId === d.UserId);
    const _objDepartment = DepartmentList?.find((d) => Object?.DepartmentId === d.DepartmentId);
    const _objAssignment = AssignmentList?.find((d) => Object?.AssignmentId === d.AssignmentId);
    useEffect(()=> {},[Object, Content, UserMentorsList, DepartmentList, AssignmentList]);
    return (
        <React.Fragment>
            <section style={{ ...ReportStyle.section }}>
                <div style={{ ...ReportStyle.section_title }}>
                    <span style={{ ...ReportStyle.section_number }}>
                        01
                    </span>

                    <h2 style={{ ...ReportStyle.h2 }}>
                        {GetBusinessLabel("FeedbackFormHeader0")}
                    </h2>
                </div>

                <div style={{ ...ReportStyle.info_grid }}>
                    <div style={{ ...ReportStyle.field }}>
                        <span style={{ ...ReportStyle.field_label }}>
                            {GetBusinessLabel("Contributor")}
                        </span>

                        <span style={{ ...ReportStyle.field_value }}>
                            {Content?.MenteeFirstName} {Content?.MenteeLastName}
                        </span>
                    </div>

                    <div style={{ ...ReportStyle.field }}>
                        <span style={{ ...ReportStyle.field_label }}>
                            {GetBusinessLabel("Function")}
                        </span>

                        <span style={{ ...ReportStyle.field_value }}>
                            {_objAssignment?.[`AssignmentName${appLang}`]}
                        </span>
                    </div>

                    <div style={{ ...ReportStyle.field, ...ReportStyle.no_right_border }}>
                        <span style={{ ...ReportStyle.field_label }}>
                            {GetBusinessLabel("Area")}
                        </span>

                        <span style={{ ...ReportStyle.field_value }}>
                            {_objDepartment?.DepartmentName}
                        </span>
                    </div>

                    <div style={{ ...ReportStyle.field, ...ReportStyle.no_bottom_border }}>
                        <span style={{ ...ReportStyle.field_label }}>
                            {GetBusinessLabel("ResponsibleMentor")}
                        </span>

                        <span style={{ ...ReportStyle.field_value }}>
                            {_objUser?.FirstName} {_objUser?.LastName}
                        </span>
                    </div>

                    <div style={{ ...ReportStyle.field, ...ReportStyle.no_bottom_border }}>
                        <span style={{ ...ReportStyle.field_label }}>
                            {Content?.[`PeriodLabelName${GetAppLang()}`]}
                        </span>

                        <span style={{ ...ReportStyle.field_value }}>
                            {Content?.[`PeriodLabelName${GetAppLang()}`]} {GetSystemLabel("of")} {Content?.CycleYear}
                        </span>
                    </div>

                    <div style={{ ...ReportStyle.field, ...ReportStyle.no_right_border, ...ReportStyle.no_bottom_border }}>
                        <span style={{ ...ReportStyle.field_label }}>
                            {GetBusinessLabel("FeedbackFormDateFeed")}
                        </span>

                        <span style={{ ...ReportStyle.field_value }}>
                            {DisplayDateAsString(Object?.FeedBackDate, true)}
                        </span>
                    </div>
                </div>
            </section>
        </React.Fragment>
    );
});

const DocumentHistory = React.memo(({...props}) => {
    const { Content, History = null} = props;
    useEffect(() => {}, [History]);
    return (
        <React.Fragment>
            <section
                style={{
                    ...ReportStyle.history,
                    ...(!History?.FeedBackId ? { gridTemplateColumns: "1fr" } : {})
                }}
            >
                <div>
                    <div style={{ ...ReportStyle.history_title }}>
                        {Content?.[`PeriodLabelName${GetAppLang()}`]} {GetSystemLabel("of")} {Content?.CycleYear}
                    </div>

                    <div style={{ ...ReportStyle.history_subtitle }}>
                        {GetBusinessLabel("FeedbackFormLabel7")} {Content?.MenteeFirstName} {Content?.MenteeLastName}
                    </div>

                    {History?.MentorId && (
                        <div style={{ ...ReportStyle.history_tags }}>
                            <span style={{ ...ReportStyle.tag }}>
                                <strong style={{ ...ReportStyle.tag_strong }}>
                                    {GetBusinessLabel("ResponsibleMentor")}:
                                </strong>{" "}
                                {History?.MentorFirstName}{History?.MentorLastName}
                            </span>

                            <span style={{ ...ReportStyle.tag }}>
                                <strong style={{ ...ReportStyle.tag_strong }}>
                                    {GetBusinessLabel("Area")}:
                                </strong>{" "}
                                {History?.DepartmentName}
                            </span>

                            <span style={{ ...ReportStyle.tag }}>
                                <strong style={{ ...ReportStyle.tag_strong }}>
                                    {GetBusinessLabel("Function")}:
                                </strong>{" "}
                                {History?.[`AssignmentName${appLang}`]}
                            </span>
                        </div>
                    )}
                </div>

                {History?.FeedBackId ? (
                    <div style={{ ...ReportStyle.side_metrics }}>
                        <div style={{ ...ReportStyle.metric }}>
                            <span style={{ ...ReportStyle.metric_label }}>
                                {GetBusinessLabel("LastFeedBack")}
                            </span>

                            <span style={{ ...ReportStyle.metric_value }}>
                                {History?.FeedBackDate && (
                                    DateToString({
                                        displayTime: false,
                                        date: DateFromIsoString(History?.FeedBackDate)
                                    })
                                )}
                            </span>
                        </div>

                        <div style={{ ...ReportStyle.metric }}>
                            <span style={{ ...ReportStyle.metric_label }}>
                                {GetBusinessLabel("FeedbackFormLabel8")}
                            </span>

                            <span style={{ ...ReportStyle.metric_value }}>
                                {History?.[`DevelopmentStageName${GetAppLang()}`]}
                            </span>
                        </div>
                    </div>
                ) : null}
            </section>
        </React.Fragment>
    );
});

const ExportedContent = React.memo(({...props}) => {
    const {
        History,
        Object,
        StageList,
        UserMentorsList,
        DepartmentList,
        AssignmentList,
        DepartmentAssignmentList,
        Content,
    } = props;
    return (
        <React.Fragment>
            <main style={{ ...ReportStyle.page }}>
                <header style={{ ...ReportStyle.report_header }}>
                    <div>
                        <p style={{ ...ReportStyle.eyebrow }}>
                            {Content?.[`PeriodLabelName${GetAppLang()}`]} {GetSystemLabel("of")} {Content?.CycleYear}
                        </p>

                        <h1 style={{ ...ReportStyle.h1 }}>
                            {GetBusinessLabel("FeedbackFormLabel7")} {Content?.MenteeFirstName} {Content?.MenteeLastName}
                        </h1>

                        <p style={{ ...ReportStyle.subtitle }}>
                            {GetBusinessLabel("FeedbackFormHeader1")}, {GetBusinessLabel("FeedbackFormHeader2")}, {GetBusinessLabel("FeedbackFormHeader3")} e {GetBusinessLabel("FeedbackFormHeader4")}
                        </p>
                    </div>

                    <aside style={{ ...ReportStyle.meta_box }}>
                        <span style={{ ...ReportStyle.meta_label }}>
                            {GetBusinessLabel("FeedbackFormDateFeed")}
                        </span>

                        <span style={{ ...ReportStyle.meta_value }}>
                            {DisplayDateAsString(Object?.FeedBackDate, true)}
                        </span>
                    </aside>
                </header>

                <div style={{ ...ReportStyle.report_header_accent }} />

                <DocumentHistory Content={Content} History={History} DepartmentList={DepartmentList} AssignmentList={AssignmentList}/>

                <DocumentInfo Content={Content} Object={Object} UserMentorsList={UserMentorsList} DepartmentList={DepartmentList} AssignmentList={AssignmentList}/>

                <DocumentCycle Object={Object} />

                <DocumentPlan Object={Object}/>

                <DocumentStage Object={Object} StageList={StageList}/>

                <DocumentSteps Object={Object} />
            </main>
        </React.Fragment>
    );
});

const footerTemplate = React.memo((props) => {
    return (
        <div style={{ position: 'absolute', bottom: '15px', width: '100%'}} className={[Style.d_flex, Style.justify_content_center, Style.align_items_center].join(" ")}>
            <div style={{ ...ReportStyle.footer }}>
                <span> {GetBusinessLabel("PDFFeedBackFooterLabel0")} {DisplayDateAsString(getDateNow(), true)}</span>
                <span> <strong style={{ ...ReportStyle.footer_strong }}>{GetBusinessLabel("ApplicationName")}</strong> {GetBusinessLabel("PDFFeedBackFooterLabel1")}</span>
                <span> {props.pageNum} {GetSystemLabel("of")} {props.totalPages}</span>
            </div>
        </div>
    );
});

export const FeedBackDocument    = React.memo(({...props}) => {
    const { ExternalRef = null,
            Save = false,
            OnDone,
            History, 
            Object, 
            StageList, 
            UserMentorsList,
            DepartmentList, 
            AssignmentList, 
            DepartmentAssignmentList,
            Content,
            DisplayPrivate = true,
            DisplayStage = true,
    }                            = props;

    const internalRef = useRef();
    const resolvedRef = ExternalRef || internalRef;

    // Identify what this export is allowed to carry, then shape the data
    // accordingly instead of threading the raw flags through every child.
    const exportedObject = useMemo(() => {
        if (!Object) return Object;
        const allowPrivate = DisplayPrivate === true;
        return {
            ...Object,
            ManagerPrivateNotes: allowPrivate ? Object.ManagerPrivateNotes : "",
        };
    }, [Object, DisplayPrivate]);

    const exportedStageList = DisplayStage === true ? StageList : null;

    useEffect(() => {
        if (Save && resolvedRef.current) {
            resolvedRef.current.save();
            setTimeout(() => {
                OnDone();
            }, 500);
        }
    }, [Save]);

    return (
        <React.Fragment>
        {Save ?
            (<PDFExport
                ref={resolvedRef}
                scale={0.5}
                paperSize={"A4"}
                fileName={`${Content?.MenteeFirstName}${Content?.MenteeLastName}.pdf`}
                forcePageBreak=".page-break"
                pageTemplate={footerTemplate}
            >
                <PDFMargin bottom="30mm"/>
                <div className="custom_override_document">
                    <ExportedContent
                        History={History}
                        Object={exportedObject}
                        StageList={exportedStageList}
                        UserMentorsList={UserMentorsList}
                        DepartmentList={DepartmentList}
                        AssignmentList={AssignmentList}
                        DepartmentAssignmentList={DepartmentAssignmentList}
                        Content={Content}
                    />
                </div>
            </PDFExport>)
        :
        null}
        </React.Fragment>
    );
});